export const shouldIgnoreFieldError = (fieldName: string): boolean =>
  fieldName === "asset_type";
